export default __webpack_public_path__ + "static/android-086a65381303c82fe143bd0192689850.svg";